/**
 * Copyright 2025 Paion Data. All rights reserved.
 */
import styled from "styled-components";

export const StyledHeader = styled.header<{ $backgroundImg: string }>`
  &:before {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: 100%;
    height: calc(100% + 15rem);
    background-image: radial-gradient(rgba(255, 255, 255, 0), #0a1e27), url(${(props) => props.$backgroundImg});
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    z-index: -1;
  }

  position: relative;
  height: 100vh;
`;
